/**
 * User: scarlson
 * Date: 03/21/13
 * Time: 01:12 PM
 */

define(function (require) {
    'use strict';
    var EasyDialog = require('easyDialog'),

        template_html = require('common/templates/Alert.html'),
        template = _.template(template_html);

    return Backbone.View.extend({
        title: i18n.alert.title,
        text: '&nbsp;',
        buttonText: i18n.buttons.CLOSE,
        container: 'default',
        containerClass: '',
        buttonClass: 'orange-btn',
        margin: 100,
        onClosed: $.noop,
        dynamicHeight: true,
        focusButton: true,

        initialize: function () {
            if (this.options.title) {
                this.title = this.options.title;
            }

            if (this.options.text) {
                this.text = this.options.text;
            }

            if (this.options.buttonText) {
                this.buttonText = this.options.buttonText;
            }

            if (this.options.container) {
                this.container = this.options.container;
            }

            if (this.options.containerClass) {
                this.containerClass = this.options.containerClass;
            }

            if (this.options.buttonClass) {
            	this.buttonClass = this.options.buttonClass;
            }

            if (this.options.onClosed) {
                this.onClosed = this.options.onClosed;
            }

            if (_.isBoolean(this.options.dynamicHeight)) {
                this.dynamicHeight = this.options.dynamicHeight;
            }

            if (_.isBoolean(this.options.focusButton)) {
                this.focusButton = this.options.focusButton;
            }

            this.render();
        },

        render: function () {
            var me = this,
                title = this.title,
                text = this.text,
                buttonText = this.buttonText,
                containerClass = this.containerClass,
                buttonClass = this.buttonClass,
                content = template({i18n: i18n, title: title, text: text, buttonText: buttonText, containerClass: containerClass, buttonClass: buttonClass}),
                close = function() {
                    $.easydialog.close(me.container);
                },
                onComplete = function() {
                    var $alert = me._setAlertHandle(),
                        $closeButton = $alert.find('a.close-btn');

                    $closeButton.click(function(event) {
                        event.preventDefault();

                        close();
                    });

                    if (me.dynamicHeight) {
                        me._setHeight();
                    }

                    if (me.focusButton) {
                        $closeButton.focus();
                    }
                };

            $.easydialog({
                container: me.container,
                content: content,
                onClosed: me.onClosed,
                onComplete: onComplete
            });

            return this;
        },

        _setAlertHandle: function() {
            this.$alert = $('#alert');

            return this.$alert;
        },

        _setHeight: function() {
            var alertHeight = this.$alert.height(),
                contentHeight = this.$alert.find('.alert-txt').height(),
                winHeight = $(window).height(),
                newAlertHeight = null,
                newContentHeight = null;

            if ((alertHeight + (this.margin * 2)) > winHeight) {
                newAlertHeight = winHeight - (this.margin * 2);

                if (newAlertHeight < 300) {
                    newAlertHeight = 300;
                }

                newContentHeight = newAlertHeight - (alertHeight - contentHeight);

                this.$alert.height(newAlertHeight);
                this.$alert.find('.alert-txt').height(newContentHeight);

                this.$alert.find('.alert-text-holder').addClass('scroll');
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/Alert.js
// module id = 231
// module chunks = 27 28 29